module.exports = __webpack_public_path__ + "static/monstera-7b999bdf35728deb8bf7b577523a1cd5.jpg";